export const getGalleryImageUrl = (imageUrl: string, width: number) =>
  `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=${width}`

export const getGalleryPhotoLabel = (photo: {
  id: number
  title?: string | null
}) => photo.title?.trim() || `Photo ${photo.id}`

export const getGalleryPhotoDownloadUrl = (photo: {
  id: number
  imageUrl: string
  title?: string | null
}) => {
  const params = new URLSearchParams({
    filename: photo.title?.trim() || `gallery-photo-${photo.id}`,
    url: photo.imageUrl,
  })

  return `/api/gallery-photo-download/?${params.toString()}`
}
